import { createRouter, createWebHashHistory } from "vue-router";
import webRoutes from "./webRouter";
import mobileRoutes from "./mobileRouter";
import store from "../store";
import { nextTick } from "vue";
const router = createRouter({
  // history: createWebHistory(),
  history: createWebHashHistory(),
  //   routes,
  routes: [],
  scrollBehavior(to, from, savedPosition) {
    console.log(11111111111, to, savedPosition);
    // 读取跳转前存入的触底状态，决定是否强制置顶
    const isFromBottom = router._isPageBottom || false;

    // 触底 → 强制返回top:0，覆盖savedPosition；未触底 → 保留原生savedPosition
    const result = isFromBottom
      ? { top: 0, behavior: "auto" }
      : savedPosition
      ? savedPosition
      : { top: 0 };

    // 清空临时状态，避免影响下一次路由跳转
    router._isPageBottom = false;
    to._scrollTop = result.top;
    return result;
  },
});

// 初始化路由临时属性（存储触底状态，页面刷新后重置）
router._isPageBottom = false;

// 全局前置守卫：跳转前判断页面是否触底，并存储状态
router.beforeEach((to, from, next) => {
  // 跳过初始路由
  if (!from.name) {
    next();
    return;
  }

  // 跳转前实时判断页面是否触底
  const isReachBottom = (offset = 10) => {
    const docEl = document.documentElement;
    const body = document.body;
    // 跳转前的最终滚动位置
    const scrollTop = window.scrollY || docEl.scrollTop || body.scrollTop;
    const clientHeight = docEl.clientHeight || body.clientHeight;
    const scrollHeight = docEl.scrollHeight || body.scrollHeight;
    return scrollTop + clientHeight + offset >= scrollHeight;
  };

  // 将触底状态存入路由临时属性
  router._isPageBottom = isReachBottom();
  next();
});
let timer = null;
// 监听路由变化
router.afterEach((to) => {
  // 动态设置浏览器标题
  console.log(to, "=====路由变化");
  // 清除之前的定时器
  // if (timer) {
  //   clearTimeout(timer);
  // }
  // if (to?._scrollTop) {
  //   timer = setTimeout(() => {
  //     console.log(to?._scrollTop, "to?._scrollTop");
  //     window.scrollTo(0, to?._scrollTop || 0);
  //     store.commit("setScrollTop", to?._scrollTop);
  //   }, 1000);
  // }
});

export default router;
export { mobileRoutes, webRoutes };
